import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { IContract } from '../../../../../model/shared/IContract';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';

interface IContractAmendmentIconProps {
    contract?: IContract;
}

/** Marks a long-term contract that has an amendment: waiting for a signature or already signed */
export const ContractAmendmentIcon = ({ contract }: IContractAmendmentIconProps) => {
    const { t } = useTranslation();
    const prefix = 'brand.campaign.book.contract.modal.annex';

    const isPending = !!contract?.openAnnex;
    if (!isPending && !contract?.isAnnex) {
        return null;
    }
    const number = isPending ? contract?.openAnnex?.annexNumber : contract?.annexNumber;

    return (
        <TooltipOverlay content={t(`${prefix}.${isPending ? 'icon_pending' : 'icon_signed'}`, { number })}>
            <span className={`d-inline-flex align-items-center ml-2 ${isPending ? 'text-warning' : 'text-success'}`}>
                <FiFileText size={18} />
            </span>
        </TooltipOverlay>
    );
};
